// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2UWoW","content":"styles_content__1yZgB"};